// extracted by mini-css-extract-plugin
export default {"feedCount":"_2QThe _34xFj _2AZKg"};